<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1ZM6.4 11.2L3.8 8.6L4.5 7.9L6.4 9.8L11.5 4.8L12.2 5.5L6.4 11.2Z"
      fill="currentcolor" />
  </svg>
</template>
